import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { ClI18nConfig, ClLabels } from '@corelabs/angular/ui';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

// Lists every label, so one a library upgrade adds fails the build instead of showing in English.
const CL_LABEL_KEYS: Record<keyof ClLabels, string> = {
    chooseDate: marker('cl.ui.choose-date'),
    clearDate: marker('cl.ui.clear-date'),
    clearSelection: marker('cl.ui.clear-selection'),
    invalidDate: marker('forms.error.invalid-date'),
    previousMonth: marker('cl.ui.previous-month'),
    nextMonth: marker('cl.ui.next-month'),
    previousYear: marker('cl.ui.previous-year'),
    nextYear: marker('cl.ui.next-year'),
    previousYears: marker('cl.ui.previous-years'),
    nextYears: marker('cl.ui.next-years'),
    month: marker('cl.ui.month'),
    year: marker('cl.ui.year'),
    closeDialog: marker('common.close'),
    closeMessage: marker('messages.close'),
    loading: marker('common.loading'),
    severityDanger: marker('cl.ui.severity-danger'),
    severityWarn: marker('cl.ui.severity-warn'),
    severitySuccess: marker('cl.ui.severity-success'),
    severityInfo: marker('cl.ui.severity-info'),
    pagination: marker('common.table.paginator.label'),
    firstPage: marker('common.table.paginator.first'),
    previousPage: marker('common.table.paginator.previous'),
    nextPage: marker('common.table.paginator.next'),
    lastPage: marker('common.table.paginator.last'),
    rowsPerPage: marker('common.table.paginator.page-size'),
    showPassword: marker('cl.ui.show-password'),
    hidePassword: marker('cl.ui.hide-password'),
    chooseFile: marker('cl.ui.choose-file'),
    removeFile: marker('cl.ui.remove-file'),
};

export function clI18nConfig(): Signal<ClI18nConfig> {
    const translateService = inject(TranslateService);

    return toSignal(
        translateService.stream(Object.values(CL_LABEL_KEYS)).pipe(
            map((translations: Record<string, string>): ClI18nConfig => ({
                labels: Object.fromEntries(Object.entries(CL_LABEL_KEYS).map(([label, key]) => [label, translations[key]])),
            })),
        ),
        { initialValue: {} },
    );
}
